import styled from 'styled-components';

// Refill Packs
export const RefillPacksGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 24px;
	margin-top: 24px;

	@media (max-width: 1024px) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

// Subscription
export const SectionSubheading = styled.p`
	font-size: 16px;
	color: ${(p) => p.theme.gray[600]};
	margin-bottom: 32px;
`;

// Organizations
export const OrgHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 24px;
`;

export const OrgGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 24px;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

export const OrgCard = styled.div`
	background: ${(p) => p.theme.gray[0]};
	padding: 32px;
	border-radius: 12px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
	transition: all 0.2s ease-in-out;
	border: 2px solid transparent;
`;

export const OrgCardHeader = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	margin-bottom: 20px;
`;

export const OrgInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const OrgName = styled.h3`
	font-size: 20px;
	font-weight: 600;
	color: ${(p) => p.theme.gray[1000]};
	margin: 0;
`;

export const OrgStats = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 16px;
	margin-bottom: 24px;
`;

export const OrgStat = styled.div`
	background: ${(p) => p.theme.gray[100]};
	padding: 16px;
	border-radius: 8px;
`;

export const OrgStatLabel = styled.div`
	font-size: 12px;
	color: ${(p) => p.theme.gray[400]};
	margin-bottom: 4px;
`;

export const OrgStatValue = styled.div`
	font-size: 20px;
	font-weight: 600;
	color: ${(p) => p.theme.gray[1000]};
`;

export const OrgActions = styled.div`
	display: flex;
	gap: 12px;
`;

export const ViewButton = styled.button`
	flex: 1;
	height: 48px;
	padding: 12px 24px;
	background: ${(p) => p.theme.gray[100]};
	color: ${(p) => p.theme.gray[1000]};
	border: 1px solid ${(p) => p.theme.gray[200]};
	border-radius: 8px;
	font-weight: 600;
	font-size: 14px;
	font-family: inherit;
	transition: all 0.2s ease-in-out;

	&:hover {
		background: ${(p) => p.theme.gray[200]};
		border-color: ${(p) => p.theme.gray[400]};
	}
`;

export const LeaveOrgButton = styled.button`
	flex: 1;
	height: 48px;
	padding: 12px 24px;
	background: ${(p) => p.theme.gray[100]};
	color: ${(p) => p.theme.gray[600]};
	border: 1px solid ${(p) => p.theme.gray[200]};
	border-radius: 8px;
	font-weight: 600;
	font-size: 14px;
	font-family: inherit;
	transition: all 0.2s ease-in-out;

	&:hover {
		border-color: ${(p) => p.theme.red[500]};
		color: ${(p) => p.theme.red[500]};
	}
`;

export const CreateOrgTileWrapper = styled.div`
	background: ${(p) => p.theme.gray[0]};
	padding: 32px;
	border-radius: 12px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
	border: 2px dashed ${(p) => p.theme.gray[200]};
	display: flex;
	flex-direction: column;
	min-height: 280px;
`;

export const CreateOrgHeader = styled.h3`
	font-size: 20px;
	font-weight: 600;
	color: ${(p) => p.theme.gray[1000]};
	margin: 0 0 16px 0;
`;

export const CreateOrgDescription = styled.p`
	font-size: 14px;
	color: ${(p) => p.theme.gray[600]};
	line-height: 1.5;
	margin: 0 0 24px 0;
	flex-grow: 1;
`;

export const CreateOrgFeatureList = styled.ul`
	list-style: none;
	padding: 0;
	margin: 0 0 24px 0;
	flex-grow: 1;
`;

export const CreateOrgFeature = styled.li`
	font-size: 14px;
	color: ${(p) => p.theme.gray[600]};
	line-height: 1.5;
	padding: 6px 0;
	position: relative;
	padding-left: 20px;

	&::before {
		content: '•';
		position: absolute;
		left: 0;
		color: ${(p) => p.theme.purple[500]};
		font-weight: bold;
	}
`;
